import { Button, TableProps } from 'antd';
import classNames from 'classnames';

import { useSearchParams } from 'react-router-dom';
import { isHasAccess } from 'features/validateAccess';
import { ReactComponent as RightArrow } from 'shared/assets/icons/dynamicColor/arrow-right.svg';

import { getTimesheetsViewPermission } from '../../Timesheets.permissions';
import { AccountRow, ProjectRow, TimesheetTableRow } from '../../TimesheetsTable.types';

import styles from './ExpandIcon.module.scss';

const isGroup = (record: TimesheetTableRow): record is ProjectRow | AccountRow => {
  return 'children' in record;
};

export const ExpandIcon: Required<TableProps<TimesheetTableRow>>['expandable']['expandIcon'] = ({
  expanded,
  onExpand,
  record,
}) => {
  const [searchParams] = useSearchParams();

  const isAllowedToView = isHasAccess(
    getTimesheetsViewPermission(searchParams.get('accountId') ?? '', searchParams.get('projectId') ?? ''),
  );

  if ((record && !isGroup(record)) || !isAllowedToView) {
    return null;
  }

  return (
    <Button
      type="text"
      icon={<RightArrow className={classNames([styles.icon, { [styles.expanded]: expanded }])} />}
      onClick={(e) => {
        onExpand(record, e);
      }}
      className={styles.expandBtn}
    />
  );
};
